import { BeneficiaryFilterStringType } from '@repo/shared/dtos/beneficiary'
import { StringSchemaItem } from '@repo/shared/dtos/structured-data'

import { FilterWrapper } from './FilterWrapper'
import StringFilterForm from './StringFilterForm'
import { FilterProps } from './types'

export default function StringFilter(
  props: FilterProps<BeneficiaryFilterStringType, StringSchemaItem>,
) {
  if (props.readonly) return <FilterWrapper {...props} />
  return (
    <FilterWrapper
      {...props}
      renderForm={(onCancel) => (
        <StringFilterForm filter={props.filter} onChange={props.onChange} onCancel={onCancel} />
      )}
    />
  )
}
